/**
 * Typed-ish helpers for the public read API. All endpoints are campaign-safe enforced
 * server-side, so the client never has to special-case anonymisation.
 */
import { api, apiClient } from './apiClient.js';

export const publicApi = {
  served: (params) => apiClient.get('/public/served', { params }), // returns full envelope (meta.page)
  servedDetail: (id) => api.get(`/public/served/${id}`),
  impact: () => api.get('/public/impact'),
  stats: () => api.get('/public/stats'),
  testimonials: () => api.get('/public/testimonials'),
  settings: () => api.get('/public/settings'),
  // General enquiry (contact / partnership / volunteer / CSR / media) — NOT case intake.
  enquiry: (body) => api.post('/enquiries', body),
};

export default publicApi;
